import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface FileUploadState {
  id: string;
  file: File;
}

const initialState: FileUploadState[] = [];

export const fileUploadSlice = createSlice({
  name: 'fileUpload',
  initialState,
  reducers: {
    addFile: (state, action: PayloadAction<FileUploadState>) => {
      state.push(action.payload);
    },
    deleteFile: (state, action: PayloadAction<string>) => {
      return state.filter((file) => file.id !== action.payload);
    },
    resetFileState: () => initialState,
  },
});

export const { addFile, deleteFile, resetFileState } = fileUploadSlice.actions;

export default fileUploadSlice.reducer;
